import qs from 'querystring'
 
import Api from '../lib/request'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'
import STATUS_CODE from '../constant/status_code'
const emptyProductListData = {
  page: {
    pageNum: 0,
    total: 0,
  },
  list: [],
}
const url = COOKIECONSTANT.REQUEST_HOST

const getTopicItems = (data) => {
  return new Promise((resolve, reject) => {
    const queryUrl = `${url}?${qs.stringify(data)}`
    Api.get(queryUrl, {
      headers: {
        'X-Host': 'mall.cfg.topic.product.list',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if (data.status === STATUS_CODE.ACTIVITY_OUT_LINE){
        return resolve(STATUS_CODE.ACTIVITY_OUT_LINE)
      }
      if(data.status === STATUS_CODE.ACTIVITY_OUT_TIME){
        return resolve(STATUS_CODE.ACTIVITY_OUT_TIME)
      }
      if (data.status === STATUS_CODE.EMPTY_LIST) {
        return resolve(emptyProductListData)
      }
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}

const getTopicBillboards = (data) => {
  return new Promise((resolve, reject) => {
    const queryUrl = `${url}?${qs.stringify(data)}`
    Api.get(queryUrl, {
      headers: {
        'X-Host': 'mall.cfg.topic.details',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status !== 0 ) {
        return reject(data.msg)
      }
      resolve(data.data)
    },e => {
      reject(e)
    })
  })
}
export default {
  getTopicItems,
  getTopicBillboards
}
